import React, { useState, useCallback, useRef, Fragment } from "react";
import PropTypes from "prop-types";
import { FormHelperText, TextField, Button, Checkbox, Typography, FormControlLabel, Select, MenuItem } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import FormDialog from "../../../shared/components/FormDialog";
import HighlightedInformation from "../../../shared/components/HighlightedInformation";
import ButtonCircularProgress from "../../../shared/components/ButtonCircularProgress";
import VisibilityPasswordTextField from "../../../shared/components/VisibilityPasswordTextField";
import { Auth, Amplify } from 'aws-amplify';
import aws_exports from '../../../aws-exports';
import 'react-phone-number-input/style.css';
import en from 'react-phone-number-input/locale/en'
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
const CountrySelect = ({ value, onChange, labels, ...rest }) => (
<Select
  {...rest}
  value={value}
  onChange={event => onChange(event.target.value || undefined)}>
  <MenuItem value="" style={ { maxWidth:80 } }>
    {labels['ZZ']}
  </MenuItem>
  {getCountries().map((country) => (
    <MenuItem key={country} value={country} >
      +{getCountryCallingCode(country)}{" "}{labels[country]}
    </MenuItem>
  ))}
</Select>
)
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
const phoneStyle = {
  display: 'flex',
  alignItems: 'center',
  verticalAlign:"middle"
};
Amplify.configure(aws_exports);
const styles = (theme) => ({
  link: {
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.complex,
      easing: theme.transitions.easing.easeInOut,
    }),
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:enabled:hover": {
      color: theme.palette.primary.dark,
    },
    "&:enabled:focus": {
      color: theme.palette.primary.dark,
    },
  },

});
async function signUp(username, password, company, given_name, family_name, job_title, phone_number, int_phone_code,callback) {
    try {
        var int_code_num = getCountryCallingCode(int_phone_code);
        phone_number = parsePhoneNumber("+"+int_code_num+phone_number).number.toString()
        console.log("Phone Parsed", phone_number);

        const { user } = await Auth.signUp({
            username,
            password,
            attributes: {
              'custom:company': company,
              'custom:job_title': job_title,
              given_name,
              family_name,
              phone_number
            }
        });
        return callback.onSuccess(user);

    } catch (error) {
        console.log('error signing up:', error);
        return callback.onFailure(error)
    }
}
function RegisterDialog(props) {
  const { setStatus, theme, onClose, openTermsDialog, status, classes, openLoginDialog, setLoginStatus, windowDimensions, setWindowDimensions } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [hasTermsOfServiceError, setHasTermsOfServiceError] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const registerTermsCheckbox = useRef();
  const registerPassword = useRef();
  const registerPasswordRepeat = useRef();
  const registerEmail = useRef();
  const registerCompany = useRef();
  const registerGivenName = useRef();
  const registerFamilyName = useRef();
  const registerPhoneNumber = useRef();
  const registerJobTitle = useRef();
  const registerIntPhoneCode = useRef();

  const [validLength, setValidLength] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [lowerCase, setLowerCase] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);
  const [match, setMatch] = useState(false);
  const [phoneValue, setPhoneValue] = useState(false);
  const [country, setCountry] = useState('US');
  console.log("windowDimensions", windowDimensions);
  function hasNumber(myString) {
    return /\d/.test(myString);
  }
  function hasSpechialChar(myString){
    return /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(myString);
  }
  function passToLogin(){
    setLoginStatus("registerPassOff");
    openLoginDialog();
  }
  const register = useCallback(() => {
    if (!registerTermsCheckbox.current.checked) {
      setHasTermsOfServiceError(true);
      return;
    }
    console.log("Checking pass length");
    if (registerPassword.current.value.length < 12){
      setStatus("passwordTooShort");
      return;
    }
    if (
      registerPassword.current.value !== registerPasswordRepeat.current.value
    ) {
      setStatus("passwordsDontMatch");
      return;
    }if (registerPassword.current.value.toLowerCase() === registerPassword.current.value){
      setStatus("passwordsRequiresUppercase");
      return;

    }if (registerPassword.current.value.toUpperCase() === registerPassword.current.value){
      setStatus("passwordsRequiresLowercase");
      return;

    }if (!hasNumber(registerPassword.current.value)){
      setStatus("passwordsRequiresNumber");
      return;

    }if (!hasSpechialChar(registerPassword.current.value) ){
      setStatus("passwordsRequiresSymbol");
      return;

    }if (!isValidPhoneNumber("+"+getCountryCallingCode(registerIntPhoneCode.current.value)+registerPhoneNumber.current.value)){
      setStatus("phoneNumberInvalid");
      return;
    }

    setStatus(null);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);



  signUp(registerEmail.current.value, registerPassword.current.value, registerCompany.current.value, registerGivenName.current.value, registerFamilyName.current.value, registerJobTitle.current.value, registerPhoneNumber.current.value, registerIntPhoneCode.current.value, {
      onSuccess: function (result) {
            console.log("success");
            setStatus("accountCreated");

        },
      onFailure: function(err) {
          console.log('failed to signup');
          setIsLoading(false);
          console.log(JSON.stringify(err));
          try {
              setStatus(JSON.parse(JSON.stringify(err))["code"]);

          } catch (error) {
              setStatus("unknownError");
          }

      },
    });
  }, [setIsLoading,
  setStatus,
  setHasTermsOfServiceError,
  registerPassword,
  registerPasswordRepeat,
  registerTermsCheckbox,
  registerEmail,
  registerGivenName,
  registerFamilyName,
  registerPhoneNumber,
  registerCompany,
  registerJobTitle,
  registerIntPhoneCode]);

  return (
    <FormDialog
      loading={isLoading}
      onClose={onClose}
      open

      headline="Register"
      onFormSubmit={(e) => {
        e.preventDefault();
        register();
      }}
      hideBackdrop
      hasCloseIcon
      content={
        <div style={{maxHeight: windowDimensions.height-300, overflowY: "scroll", WebkitScrollbar:{width: 0, background: "transparent"}}}>
        <Fragment>
          <TextField
            autoFocus
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={status === "invalidGivenName"}
            label="First Name"
            inputRef={registerGivenName}
            autoComplete="off"
            onChange={() => {
              if (status === "invalidGivenName") {
                setStatus(null);
              }
            }}
            FormHelperTextProps={{ error: true }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={status === "invalidFamilyName"}
            label="Last Name"
            inputRef={registerFamilyName}
            autoComplete="off"
            onChange={() => {
              if (status === "invalidFamilyName") {
                setStatus(null);
              }
            }}
            FormHelperTextProps={{ error: true }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={status === "invalidCompany"}
            label="Company"
            inputRef={registerCompany}
            autoComplete="off"
            onChange={() => {
              if (status === "invalidCompany") {
                setStatus(null);
              }
            }}
            FormHelperTextProps={{ error: true }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={status === "invalidJobTitle"}
            label="Job Title"
            inputRef={registerJobTitle}
            autoComplete="off"
            onChange={() => {
              if (status === "invalidJobTitle") {
                setStatus(null);
              }
            }}
            FormHelperTextProps={{ error: true }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={status === "invalidEmail"}
            label="Email Address"
            inputRef={registerEmail}
            autoComplete="off"
            type="email"
            onChange={() => {
              if (status === "invalidEmail") {
                setStatus(null);
              }
            }}
            FormHelperTextProps={{ error: true }}
          />
          <div style={phoneStyle}>
            <CountrySelect
            variant="outlined"
            required
            style={ { height: 40, maxWidth:125, marginRight:10 } }
            labels={en}
            value={country}
            onChange={setCountry}
            inputRef={registerIntPhoneCode}

            />
            <TextField
              label="Phone Number"
              variant="outlined"
              margin="normal"
              error={
                status === "phoneNumberInvalid"
              }
              inputRef={registerPhoneNumber}
              required
              fullWidth
              onChange={() => {
                if (status === "phoneNumberInvalid") {
                  setStatus(null);
                }
              }}
              helperText={(() => {
                if (status === "phoneNumberInvalid") {
                  return "Your phone number appears to be invalid.";
                }
                return null;
              })()}/>
          </div>
          <VisibilityPasswordTextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={
              status === "passwordTooShort" || status === "passwordsDontMatch"
            }
            label="Password"
            inputRef={registerPassword}
            autoComplete="off"
            onChange={() => {
              if (
                status === "passwordTooShort" ||
                status === "passwordsDontMatch"
              ) {
                setStatus(null);
              }
            }}
            helperText={(() => {
              if (status === "passwordTooShort") {
                return "Your password must be at least 12 characters long.";
              }
              if (status === "passwordsDontMatch") {
                return "Your passwords do not match.";
              }
              if (status === "passwordsRequiresUppercase") {
                return "Your password must have at least 1 uppercase letter.";
              }
              if (status === "passwordsRequiresLowercase") {
                return "Your password must have at least 1 lowercase letter.";
              }
              if (status === "passwordsRequiresNumber") {
                return "Your password must have at least 1 number.";
              }
              if (status === "passwordsRequiresSymbol") {
                return "Your password must have at least 1 symbol.";
              }
              return null;
            })()}
            FormHelperTextProps={{ error: true }}
            isVisible={isPasswordVisible}
            onVisibilityChange={setIsPasswordVisible}
          />
          <VisibilityPasswordTextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={
              status === "passwordTooShort" || status === "passwordsDontMatch"
            }
            label="Repeat Password"
            inputRef={registerPasswordRepeat}
            autoComplete="off"
            onChange={() => {
              if (
                status === "passwordTooShort" ||
                status === "passwordsDontMatch"
              ) {
                setStatus(null);
              }
            }}
            helperText={(() => {
              if (status === "passwordTooShort") {
                return "Your password must be at least 12 characters long.";
              }
              if (status === "passwordsDontMatch") {
                return "Your passwords do not match.";
              }
              if (status === "passwordsRequiresUppercase") {
                return "Your password must have at least 1 uppercase letter.";
              }
              if (status === "passwordsRequiresLowercase") {
                return "Your password must have at least 1 lowercase letter.";
              }
              if (status === "passwordsRequiresNumber") {
                return "Your password must have at least 1 number.";
              }
              if (status === "passwordsRequiresSymbol") {
                return "Your password must have at least 1 symbol.";
              }
            })()}
            FormHelperTextProps={{ error: true }}
            isVisible={isPasswordVisible}
            onVisibilityChange={setIsPasswordVisible}
          />
          <FormControlLabel
            style={{ marginRight: 0 }}
            control={
              <Checkbox
                color="primary"
                inputRef={registerTermsCheckbox}
                onChange={() => {
                  setHasTermsOfServiceError(false);
                }}
              />
            }
            label={
              <Typography variant="body1">
                I agree to the
                <span
                  className={classes.link}
                  onClick={isLoading ? null : openTermsDialog}
                  tabIndex={0}
                  role="button"
                  onKeyDown={(event) => {
                    // For screenreaders listen to space and enter events
                    if (
                      (!isLoading && event.keyCode === 13) ||
                      event.keyCode === 32
                    ) {
                      openTermsDialog();
                    }
                  }}
                >
                  {" "}
                  Terms of Service
                </span>
              </Typography>
            }
          />
          {hasTermsOfServiceError && (
            <FormHelperText
              error
              style={{
                display: "block",
                marginTop: theme.spacing(-1),
              }}
            >
              In order to create an account, you have to accept our terms of
              service.
            </FormHelperText>
          )}
          {(() => {
            if (status === "accountCreated"){
               passToLogin();
              // return (<HighlightedInformation>
              //   We have created your account. Please click on the link in the
              //   email we have sent to you before logging in.
              // </HighlightedInformation>)
            }
            if (status === "unknownError"){
              return (<HighlightedInformation>
                An unknown error has occured. Please refresh the page and try again.
                If you continue to face issues please reach out to support@presagetech.com.
              </HighlightedInformation>)
            }
            if (status === "UsernameExistsException"){
              return (<HighlightedInformation>
                It looks like you have already registered an account. Please be sure to verify your account by following the link in your email.
                Once this is completed you should be able to login. If you continue to face issues please reach out to support@presagetech.com.
              </HighlightedInformation>)
            }
            if (status === "NetworkError"){
              return (<HighlightedInformation>
                Please verify you are connected to the Internet. If you are, we are likely having issues on our end and ask that you please wait to try again. Thank you!
              </HighlightedInformation>)
            }if (status === "InvalidParameterException"){
              return (<HighlightedInformation>
                An unknown error has occured. Please verify your information is entered correctly.
                If you continue to face issues please reach out to support@presagetech.com.
              </HighlightedInformation>)
            }
          })()}

        </Fragment>
        </div>
      }
      actions={
        <Button
          type="submit"
          fullWidth
          variant="contained"
          size="large"
          color="secondary"
          disabled={isLoading}
        >
          Register
          {isLoading && <ButtonCircularProgress />}
        </Button>
      }
    />
  );
}

RegisterDialog.propTypes = {
  theme: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
  status: PropTypes.string,
  setStatus: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  openLoginDialog:PropTypes.func.isRequired,
  setLoginStatus:PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(RegisterDialog);
